<template>
    <v-app>
        <sidebar :drawer="drawer" :mini="mini"></sidebar>
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" light app color="primary">
        <Link href="/">
            <v-tooltip bottom color="primary">
                <template v-slot:activator="{ on, attrs }">
                    
                <img
                    
                    src="/img/backtoworkconnect-light-logo-1.png"
                    contain
                    class="logo"
                    v-bind="attrs"
                    v-on="on"
                    height="40"
                    width="40"
                />
                </template>
                <span>Home</span>
            </v-tooltip>
        </Link>
        
    <v-spacer />
    <Link href="/admin" v-if="canAdmin()">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs"
            v-on="on">
                <v-icon color="white">mdi-cog-outline</v-icon>
            </v-btn>
            </template>
            <span>Admin</span>
        </v-tooltip>
    </Link>
    
    
    <Link href="/profile" v-if="auth.user">
            <v-btn dark icon>
                <v-icon>mdi-account</v-icon>
            </v-btn>
            
    </Link>
    <Link href="/logout" v-if="auth.user" method="delete" >
            <v-btn dark icon>
                <v-icon>mdi-logout</v-icon>
            </v-btn>
            
    </Link>
    
    </v-app-bar>
    
    <v-main>
        
    <v-container fluid style="height:100%">
        
        <flash-messages />
            <slot />
    </v-container>
    </v-main>
    
</v-app>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue'
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'
import Sidebar from '@/Shared/Sidebar'


export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Link,
    Logo,
    MainMenu,
    Sidebar
    
  },
  props: {
    auth: Object,
  },
  data() {
    return {
    mini:false,
    drawer:true,
      
    }
  },
  methods: {
    canAdmin() {
        if (this.auth.user.roles.includes('admin'))
            return true;
        else
            return false;
    }
  }
}
</script>